import { render, staticRenderFns } from "./BossLobby.vue?vue&type=template&id=8c1a5d8c&"
import script from "./BossLobby.vue?vue&type=script&lang=ts&"
export * from "./BossLobby.vue?vue&type=script&lang=ts&"
import style0 from "./BossLobby.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports